export default {"src":"/_next/static/media/fast.745f2dea.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};